import type { IconData } from '@stacksjs/iconify-core'

export const inboxF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20 5H0l4-5h12zm0 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h6.126a4.002 4.002 0 0 0 7.748 0zM8.265 7h3.465a2 2 0 0 1-3.465 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default inboxF
